import { ALLOWED_COUNTRIES } from "../config/constants";

export const getDefaultCountry = () => {
    if (ALLOWED_COUNTRIES.length === 1) {
        return ALLOWED_COUNTRIES[0];
    }
    return '';
};
